import LogicApplicationRepository from '@/repositories/LogicApplicationRepository';

import useAPI from './useAPI';

/**
 * Resolves the LogicApplication for a registered application key, creating it on
 * first use if it doesn't exist yet -- see `logic_applications/by_key`.
 */
export const useLogicApplication = (applicationKey: string) => {
  const logicApplicationRepository = LogicApplicationRepository();

  return useAPI({
    queryKey: ['getLogicApplication', applicationKey],
    queryFn: () => logicApplicationRepository.getByKey(applicationKey),
    enabled: !!applicationKey
  });
};

/**
 * Every field a LogicApplication's LogicElements can filter on -- its machine
 * name, label, supported operators, negation support, and (if applicable) its
 * fixed set of value choices. Enough to build a criteria-editing form without
 * hardcoding any application-specific knowledge.
 */
export const useLogicFieldOptions = (applicationId?: string) => {
  const logicApplicationRepository = LogicApplicationRepository();

  return useAPI({
    queryKey: ['getLogicFieldOptions', applicationId],
    queryFn: () => logicApplicationRepository.getFieldOptions(applicationId as string),
    enabled: !!applicationId
  });
};

export default useLogicApplication;
